module.exports = __webpack_public_path__ + "img/header.e1f6ac4b.jpg";